import { Modal } from 'antd';
import useInactivity from '../hooc/useInactivity';
import React, { useEffect, useRef } from 'react';

const InactivityWarning: React.FC = () => {
    const { showWarning, resetTimer } = useInactivity();
    const modalRef = useRef<any>(null); // Lưu instance của modal

    useEffect(() => {
        if (showWarning) {
            // Nếu modal cũ đang mở, đóng nó trước khi mở modal mới
            if (modalRef.current) {
                modalRef.current.destroy();
            }
            // Mở modal mới và lưu instance
            modalRef.current = Modal.warning({
                title: "Cảnh báo",
                content: (
                    <div>
                        <p>Bạn đã không thao tác trong một thời gian dài.</p>
                        <p>Trang sẽ được làm mới trong 1 phút.</p>
                    </div>
                ),
                onOk: () => resetTimer(),
                okText: "Tiếp tục sử dụng",
            });
        }
    }, [showWarning, resetTimer]);

    return null; // Không return JSX vì modal đã được hiển thị thông qua useEffect
};

export default InactivityWarning;
